module.exports = __webpack_public_path__ + "static/media/4.adde5634.png";